module.exports = {"menu":{"home":"Accueil","events":"Événements","myYoop":"Mes Yoop","profile":"Profil","login":"Se connecter","logout":"Déconnexion","signUp":"S’inscrire","about":"À propos","careers":"Carrières","contact":"Contactez-nous","privacyPolicy":"Politiques de confidentialité","termsOfUse":"Conditions d’utilisation","support":"Support"}}


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src426716145/src/modules/web/src/js/i18n/french/menu.fr.i18n.json
// module id = 1227
// module chunks = 0